export const articleContent: Record<string, {
  title: string;
  date: string;
  author: string;
  readTime: string;
  views: string;
  category: string;
  categoryName: string;
  coverImage: string;
  content: Array<{ type: string; text: string }>;
  tags: string[];
}> = {
  "banana-nutrition-guide": {
    title: `香蕉的营养价值全解析：为什么它是运动后的最佳水果`,
    date: "2026-07-30",
    author: `向日葵编辑团队`,
    readTime: `8分钟`,
    views: "5.2万",
    category: "banana",
    categoryName: `香蕉视频`,
    coverImage: "https://readdy.ai/api/search-image?query=Fresh%20yellow%20bananas%20on%20a%20clean%20white%20marble%20surface%20with%20soft%20morning%20light%2C%20minimalist%20food%20photography%2C%20one%20banana%20peeled%2C%20elegant%20composition%2C%20warm%20natural%20tones&width=1200&height=600&seq=article-detail-01&orientation=landscape",
    content: [
      { type: "p", text: `香蕉是全球消费量最大的水果之一，每年全球香蕉产量超过1.5亿吨。它不仅口感香甜软糯，更因其丰富的营养价值被誉为"天然能量棒"。本文将全面解析香蕉的营养成分及其对人体健康的多重益处。` },
      { type: "h2", text: `香蕉的核心营养成分` },
      { type: "p", text: `一根中等大小的香蕉（约118克）含有约105卡路里的热量，主要由碳水化合物（27克）、少量蛋白质（1.3克）和极少的脂肪（0.4克）组成。除此之外，香蕉还富含多种维生素和矿物质。` },
      { type: "p", text: `钾是香蕉最知名的营养成分。一根香蕉约含422毫克钾，占每日推荐摄入量的12%。钾是维持正常血压、支持神经信号传导和肌肉收缩的关键矿物质。对于经常运动的人来说，适量补钾有助于预防运动后的肌肉痉挛。` },
      { type: "p", text: `维生素B6在香蕉中的含量也相当可观，一根香蕉可提供每日推荐摄入量的33%。维生素B6参与体内超过100种酶反应，对蛋白质代谢、红细胞生成和神经递质合成都至关重要。` },
      { type: "p", text: `此外，香蕉还是膳食纤维、维生素C、镁和锰的良好来源。每根香蕉约含3.1克膳食纤维，有助于促进肠道蠕动，改善消化功能。` },
      { type: "h2", text: `为什么香蕉是运动后的理想食物？` },
      { type: "p", text: `运动营养学研究表明，香蕉是天然的运动补给佳品。原因有三：第一，香蕉富含易消化的碳水化合物，能快速补充运动消耗的糖原储备；第二，香蕉中的钾和镁有助于调节体液平衡，减少运动后的肌肉酸痛；第三，香蕉含有天然的抗氧化物质多巴胺和儿茶素，能帮助对抗运动产生的氧化应激。` },
      { type: "p", text: `有趣的是，多项研究对比了香蕉和运动饮料的恢复效果，结果发现两者在补充能量和减轻运动后炎症方面表现相当。而香蕉作为全天然食物，还额外提供了膳食纤维和多种微量营养素。` },
      { type: "h2", text: `香蕉对心血管健康的益处` },
      { type: "p", text: `高钾低钠的饮食模式已被证实有助于降低高血压风险。香蕉作为高钾食物的代表，每天食用一根香蕉，配合整体均衡饮食，对维持心血管健康有积极作用。一项覆盖超过40,000名男性的研究发现，高钾摄入量与中风风险降低38%相关。` },
      { type: "h2", text: `不同成熟度香蕉的营养差异` },
      { type: "p", text: `有趣的是，香蕉的营养成分会随成熟度变化。未成熟的青香蕉富含抗性淀粉，是一种益生元纤维，有助于滋养肠道有益菌群。随着香蕉变黄、出现褐色斑点，抗性淀粉逐渐转化为简单糖类，使香蕉更甜更易消化。褐色斑点越多，香蕉的抗氧化水平越高。` },
      { type: "h2", text: `食用建议与注意事项` },
      { type: "p", text: `虽然香蕉营养丰富，但也要注意适量。对于肾功能不全的人群，需要限制钾的摄入量，应当在医生指导下控制香蕉摄入。对于糖尿病患者，建议选择较小且略带青色的香蕉，其升糖指数相对较低。` },
      { type: "p", text: `总体而言，每天食用1-2根香蕉对绝大多数人来说都是安全且有益的。无论是作为早餐的一部分、运动前后的能量补充，还是健康的下午茶点心，香蕉都是极佳的选择。` },
    ],
    tags: [`香蕉`, `营养价值`, `运动营养`, `健康饮食`, `水果知识`],
  },
  "watermelon-summer-health": {
    title: `夏季吃西瓜的五大健康好处，最后一条你可能不知道`,
    date: "2026-07-28",
    author: `向日葵编辑团队`,
    readTime: `6分钟`,
    views: "8.7万",
    category: "watermelon",
    categoryName: `西瓜视频`,
    coverImage: "https://readdy.ai/api/search-image?query=Refreshing%20watermelon%20slices%20on%20a%20summer%20outdoor%20setting%2C%20bright%20sunlight%2C%20green%20grass%20background%2C%20cool%20summer%20vibes%2C%20food%20photography%2C%20vibrant%20red%20and%20green%20contrast&width=1200&height=600&seq=article-detail-02&orientation=landscape",
    content: [
      { type: "p", text: `西瓜是夏季最受欢迎的消暑水果，清甜多汁的口感让人一吃就停不下来。但你可能不知道，西瓜除了好吃之外，还有很多令人惊喜的健康益处。今天就来揭秘夏日吃西瓜的五大好处。` },
      { type: "h2", text: `一、补水消暑，天然电解质饮料` },
      { type: "p", text: `西瓜的含水量高达92%，是自然界中含水量最高的水果之一。在炎热的夏季，吃一块冰镇西瓜不仅能迅速解渴，还能补充身体流失的水分和电解质。西瓜中含有的钾和镁是天然的电解质，有助于维持体液平衡。` },
      { type: "h2", text: `二、富含番茄红素，抗氧化利器` },
      { type: "p", text: `鲜红的西瓜肉是番茄红素的极佳来源。实际上，一杯西瓜汁所含的番茄红素比一个新鲜番茄还高出40%。番茄红素是一种强效抗氧化剂，有助于中和体内自由基，降低慢性炎症水平，对预防某些类型的癌症和心血管疾病有积极作用。` },
      { type: "h2", text: `三、促进运动恢复，减轻肌肉酸痛` },
      { type: "p", text: `西瓜中含有一种名为瓜氨酸的氨基酸，它能在体内转化为精氨酸，进而促进一氧化氮的生成。一氧化氮有助于扩张血管、改善血液循环。一项发表在《农业与食品化学杂志》的研究发现，运动前饮用西瓜汁的运动员，运动后24小时的肌肉酸痛感明显减轻。` },
      { type: "h2", text: `四、有益皮肤健康` },
      { type: "p", text: `西瓜中的维生素A和维生素C对皮肤健康至关重要。维生素C是胶原蛋白合成的必需营养素，有助于保持皮肤弹性和紧致。维生素A则有助于修复皮肤细胞，抵抗紫外线带来的损伤。再加上充足的水分和番茄红素的抗氧化保护，西瓜可以说是由内而外的护肤佳品。` },
      { type: "h2", text: `五、低卡路里，减肥人士的甜品替身` },
      { type: "p", text: `一杯（约152克）切块的西瓜仅含46卡路里，而且富含水分和少量膳食纤维，能够产生饱腹感。当你渴望甜食时，用西瓜代替高热量甜点，既能满足口腹之欲，又不会摄入过多热量，对控制体重十分友好。` },
      { type: "h2", text: `食用小贴士` },
      { type: "p", text: `选择西瓜时，可以轻拍瓜皮，声音清脆者为佳。西瓜切开后应尽快食用，如需存放应冷藏并密封保存，以保持新鲜度。虽然西瓜营养丰富，但由于其含水量极高且含糖，一次性不宜食用过多，以免造成肠胃不适或血糖波动。` },
    ],
    tags: [`西瓜`, `夏季水果`, `健康饮食`, `抗氧化`, `运动恢复`],
  },
  "peach-varieties-guide": {
    title: `蜜桃品种大百科：黄桃、白桃、水蜜桃有什么区别`,
    date: "2026-07-25",
    author: `向日葵编辑团队`,
    readTime: `10分钟`,
    views: "6.3万",
    category: "peach",
    categoryName: `蜜桃视频`,
    coverImage: "https://readdy.ai/api/search-image?query=Three%20different%20varieties%20of%20fresh%20ripe%20peaches%20arranged%20on%20a%20ceramic%20plate%2C%20yellow%20peach%20white%20peach%20and%20honey%20peach%2C%20soft%20natural%20lighting%2C%20elegant%20food%20photography%2C%20warm%20color%20palette&width=1200&height=600&seq=article-detail-03&orientation=landscape",
    content: [
      { type: "p", text: `蜜桃是夏季最令人期待的水果之一，饱满多汁的果肉和迷人的香气让人欲罢不能。但走进水果店，面对黄桃、白桃、水蜜桃、蟠桃等琳琅满目的品种，你是否也曾感到困惑？本文将带你全面了解各类蜜桃的特点和区别。` },
      { type: "h2", text: `蜜桃的基本分类` },
      { type: "p", text: `从果肉颜色来看，蜜桃主要分为黄肉桃和白肉桃两大类。黄桃果肉呈金黄色，酸甜适中，口感紧实有韧性，适合加工制作罐头和果酱。白桃果肉呈乳白色，甜度高酸度低，口感柔软多汁，更适合鲜食。` },
      { type: "h2", text: `水蜜桃——蜜桃之王` },
      { type: "p", text: `水蜜桃是白桃中的佼佼者，以无锡阳山水蜜桃、奉化水蜜桃最为著名。成熟的水蜜桃皮薄如纸，果肉细腻柔软，汁水丰盈，甜度可达15度以上。吃水蜜桃的方式也很特别——往往会弄得满手是汁，这才是正宗水蜜桃的标志。` },
      { type: "h2", text: `黄桃——加工与鲜食两相宜` },
      { type: "p", text: `黄桃以安徽砀山黄桃、山东肥城黄桃为代表。黄桃果肉紧致，耐储存和运输，不仅适合鲜食，更是制作黄桃罐头、黄桃果酱的优质原料。黄桃的酸甜比适中，带有独特的果香，加热后风味反而更加浓郁。` },
      { type: "h2", text: `蟠桃——扁平的另类美味` },
      { type: "p", text: `蟠桃外形扁平如盘，是蜜桃家族中辨识度最高的品种。传说中王母娘娘的蟠桃会就是以这种桃子为主角。蟠桃肉质细嫩，甜度高，果核小，可食率高，是鲜食的上佳之选。新疆和田的蟠桃品质尤为出色。` },
      { type: "h2", text: `如何挑选和保存蜜桃` },
      { type: "p", text: `挑选蜜桃时，首先闻一闻——成熟的好桃子会散发出浓郁的果香。其次观察颜色，底色发白或发黄的为佳。轻捏果实，稍有弹性说明成熟度刚好。未成熟的蜜桃可放在室温下后熟，但切忌堆叠挤压。成熟后的蜜桃应放入冰箱冷藏，并尽快食用。` },
      { type: "p", text: `无论是哪一种蜜桃，都承载着夏日的甜蜜记忆。了解不同品种的特点，选择最适合自己口味的蜜桃，才是真正的水果达人。` },
    ],
    tags: [`蜜桃`, `水果品种`, `水蜜桃`, `黄桃`, `水果选购`],
  },
};

export const relatedArticles = [
  {
    id: "a7",
    slug: "fruit-storage-tips",
    title: `水果保鲜全攻略：每种水果的最佳储存方式`,
    excerpt: `不同水果的储存方法大不相同，用对方法可以让水果保鲜时间延长一倍。`,
    date: "2026-07-16",
    readTime: `7分钟`,
  },
  {
    id: "a8",
    slug: "seasonal-fruit-calendar",
    title: `四季水果日历：每个月该吃什么水果？`,
    excerpt: `掌握水果的时令规律，吃当季水果不仅更美味，也更有益健康。`,
    date: "2026-07-12",
    readTime: `9分钟`,
  },
  {
    id: "a9",
    slug: "fruit-smoothie-recipes",
    title: `夏日水果奶昔配方大全：10分钟搞定健康早餐`,
    excerpt: `用新鲜水果制作营养丰富的水果奶昔，简单快捷又美味健康。`,
    date: "2026-07-08",
    readTime: `5分钟`,
  },
];